export default __webpack_public_path__ + "static/media/img-two.f280cd6a.png";